var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.116 2.397 19.576 1l7.828 4.444v4.063L31 11.547v8.914l-3.596 2.04v4.057L19.576 31l-2.46-1.397v-12.19L5.26 10.68l-2.917 1.656v7.318l2.914 1.655L8.4 19.535l.011-.117.027-.159a1.337 1.337 0 0 1 1.303-1.064l.157.01a1.357 1.357 0 0 1 1.186 1.351l-.009.159a1.35 1.35 0 0 1-1.334 1.201l-.147-.008a1.343 1.343 0 0 1-.436-.133l-.104-.051-3.114 1.755v3.279l6.483 3.68 1.117-.634V27.57L7.28 24.024v-.714l.747-.423 5.514 3.124v-9.059l1.344.764v11.889L12.424 31l-7.828-4.444v-4.062L1 20.453v-8.914l3.596-2.04V5.443L12.423 1l2.461 1.397v12.19L26.74 21.32l2.917-1.656v-7.318l-2.914-1.655-3.143 1.774-.011.117-.026.159a1.34 1.34 0 0 1-1.304 1.064l-.157-.01a1.357 1.357 0 0 1-1.186-1.351l.009-.159a1.35 1.35 0 0 1 1.334-1.203l.147.011c.152.02.3.065.436.133l.104.053 3.114-1.757V6.24l-6.484-3.68-1.116.634V4.43l6.261 3.547v.714l-.747.423-.896-.507-.004.001-4.614-2.618v9.033l-1.344-.763V2.397zM26.06 25.76v-2.497l-7.6 4.308v1.236l1.116.634 6.485-3.681zm-.696-3.663-6.904-3.92v7.834l6.904-3.913zM13.54 13.823V5.989L6.636 9.902l6.904 3.92zm0-10.629-1.117-.634v.001L5.94 6.244v2.494l7.6-4.308V3.193z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChsb);
export default __webpack_public_path__ + "static/media/CHSB.df4020625462d77df32d878844668973.svg";
export { ForwardRef as ReactComponent };